module.exports = __webpack_public_path__ + "static/img/4.7d93bbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news18/4.png
// module id = Rrxz
// module chunks = 1